import BaseService from '@/ecm/common/BaseService.js';

class UserWidgetService {
  baseUrl = 'user-widget';

  getForUser = () => BaseService.get({ url: `${this.baseUrl}` });
  getForUserId=(id) => BaseService.get({ url: `${this.baseUrl}/get-dashboard-widgets/${id}` })
  add = (widget) => BaseService.post({ url: `${this.baseUrl}`, data: widget });
  delete = (userWidgetID) => BaseService.delete({ url: `${this.baseUrl}/${userWidgetID}` });
  updateSettings = (settings) => BaseService.put({ url: `${this.baseUrl}/settings`, data: settings });
  updateLayout = (layout) => BaseService.put({ url: `${this.baseUrl}`, data: layout });
}

export default new UserWidgetService();